<template>
  <mdb-modal v-if="visible" centered @close="$emit('cancel')" elegant>
    <mdb-modal-header>
      <mdb-modal-title class="isi-heading-blue">Delete Review</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <p>Are you sure you want to delete this review? This action cannot be undone.</p>
      <p v-if="review && review.title"><strong>{{ review.title }}</strong></p>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn color="isi" @click="$emit('cancel')">Cancel</mdb-btn>
      <mdb-btn color="danger" @click="$emit('confirm')">Delete</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
export default {
  name: 'DeleteReviewConfirmationModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    review: {
      type: Object,
      required: false
    }
  }
};
</script>

<style scoped>
</style>